// extracted by mini-css-extract-plugin
export var quantityInput = "_hp-0";